import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, CalendarCheck, DollarSign, Hourglass, Timer } from "lucide-react";
import { StatCard } from "@/components/StatCard";
import { useI18n } from "@/i18n/I18nProvider";
import { useAuth } from "@/context/AuthContext";
import { api, errorKey, formatMoney } from "@/lib/api";

export const useMySummary = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/me/summary").then((r) => setData(r.data)).catch((e) => setError(errorKey(e)));
  }, []);
  return { data, error };
};

export default function MyDashboard() {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const { data, error } = useMySummary();
  const v = (x) => (data ? x : "—");
  return (
    <div>
      <p className="text-sm font-semibold uppercase tracking-wider text-[#8a6300]">{t("portal.summary")}</p>
      <h1 data-testid="portal-greeting" className="mt-1 font-display text-3xl font-extrabold tracking-tight text-[#000B45]">
        {t("portal.hello", { name: user.first_name })}
      </h1>
      <Link to="/portal/clock" data-testid="portal-clock-shortcut"
        className="mt-6 flex min-h-[64px] items-center justify-between rounded-2xl bg-[#000B45] px-5 text-white transition-colors hover:bg-[#000624]">
        <span className="flex items-center gap-3 text-lg font-bold"><Timer className="h-6 w-6 text-[#FEB601]" />{t("portal.clockTitle")}</span>
        <span className="rounded-full bg-[#FEB601] px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-[#000B45]">{t("common.comingSoon")}</span>
      </Link>
      {error && <p data-testid="portal-summary-error" className="mt-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{t(error)}</p>}
      <div className="mt-6 grid grid-cols-2 gap-3">
        <StatCard testId="my-hours" label={t("portal.hoursWorked")} value={v(data?.hours_worked)} icon={Clock} />
        <StatCard testId="my-days" label={t("portal.daysWorked")} value={v(data?.days_worked)} icon={CalendarCheck} />
        <StatCard testId="my-gross" label={t("portal.gross")} value={v(formatMoney(data?.gross_earned, lang))} icon={DollarSign} />
        <StatCard testId="my-pending" label={t("portal.pending")} value={v(formatMoney(data?.pending, lang))} icon={Hourglass} accent />
      </div>
    </div>
  );
}
